import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-einitial',
  templateUrl: './einitial.component.html',
  styleUrls: ['./einitial.component.css']
})
export class EinitialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
